<section>
    <div>
        <mat-card>
           
            <mat-card-header>
                <mat-card-title>Seleccione modo de entrega</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              
                <!--
                <div>
                    <p *ngIf="queueService.lugar_entrega==''" style="color:red">Seleccione lugar de entrega:</p>
                    <mat-button-toggle-group  name="fontStyle" [(ngModel)]="queueService.lugar_entrega" aria-label="Font Style">

                        <mat-button-toggle value="estacionamiento" style="
                        font-weight: bold;">Estacionamiento</mat-button-toggle>
                        <mat-button-toggle value="meson" style="
                        font-weight: bold;">Entrega en mesón</mat-button-toggle>
                        <mat-button-toggle value="pickup" style="
                        font-weight: bold;">Trastienda Pickup</mat-button-toggle>
                      </mat-button-toggle-group>
                      
                </div>-->
            <!--
                <div *ngIf="pickupService.usuario.validacion_entrega=='codigo_foto'">
                    <p>Confirma la entrega del pedido con un <b>código único</b> y <b>foto</b> otorgado por el cliente</p>
                    <button mat-raised-button color="primary" class="button btnxlarge"  (click)="presentModalInstruccionesCodigo()"><mat-icon>vpn_key</mat-icon>&nbsp;Código único</button>
                </div>


                <div *ngIf="pickupService.usuario.validacion_entrega!='codigo_foto'">
                -->
                <div>
                    <p>Confirma la entrega del pedido con un código único otorgado por el cliente</p>
                    <button mat-raised-button color="primary" class="button btnxlarge"  (click)="presentModalInstruccionesCodigo()"><mat-icon>vpn_key</mat-icon>&nbsp;Código único</button>
                </div>
                <div>
                    <p>Confirma la entrega del pedido con una foto de los bultos</p>
                    <button mat-raised-button color="primary" class="button btnlarge"    (click)="presentModalInstruccionesFoto()"><mat-icon>photo_camera</mat-icon>&nbsp;Entrega con Foto</button>
                </div>
               <!-- </div> -->
            </mat-card-content>
        </mat-card>
    </div>
    <div class="exit">
        <button mat-raised-button color="primary" class="button btnlarge" (click)="volver()" >Volver al Pedido</button>
    </div>
</section>